import { render } from "./InquiryResult.vue?vue&type=template&id=7fb986f9"
import script from "./InquiryResult.vue?vue&type=script&lang=js"
export * from "./InquiryResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__